<template>
  <div class="new">
    <div class="zlAssess">
      <!-- <div class="title">测序质量评估</div> -->
      <ZlContent :list="list" />
    </div>
  </div>
</template>
<script>
import ZlContent from "@/components/openClose/ZlContent.vue";
import { getZl } from "@/api/reportQuery";

export default {
  components: {
    ZlContent,
  },
  data() {
    return {
      list: [],
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    getData() {
      getZl({
        // labOriginalSampleNo: "W201100a5T",
        // moduleId: 58,
        // productCode: "fwa-p825",

        labOriginalSampleNo: this.$route.query.fname,
        productCode: this.$route.query.fid,
        moduleId: this.$route.query.moduleId,
      }).then((res) => {
        this.list = res.data;
      });
    },
  },
};
</script>
<style lang="less" scoped>
.new {
  padding: 20px;
}
.show-box {
  height: 20px;
  background: linear-gradient(
    360deg,
    rgba(58, 74, 134, 0) 0%,
    rgba(58, 74, 134, 0.06) 100%
  );
}
.zlAssess {
  background: @background_color;
  border-radius: 10px;
  margin-bottom: 20px;
  font-family: @family;
  padding-top: 24px;

  .title {
    height: 70px;
    line-height: 70px;
    font-size: 18PX;
    font-weight: 500;
    color: #2f354d;
    padding-left: 24px;
    position: relative;
  }
}
</style>
